import { ILongContractRequestsData } from '@pharmaplan/common';
import { groupBy } from 'rambda';

const useGetLongTermDistributions = (
  requests: Array<ILongContractRequestsData>,
  counterRequests?: Array<ILongContractRequestsData>,
  limit?: number,
) => {
  const groupByDates = groupBy(
    (prop: ILongContractRequestsData) =>
      prop?.startDate?.split('T')[0],
  );

  const groupedCounterShifts = groupByDates(counterRequests ?? []);

  const totalShifts = requests?.slice(0, limit).map((item) => {
    const date = item?.startDate?.split?.('T')?.[0];
    const { startDate, endDate } = groupedCounterShifts?.[date]?.[0] ?? {};

    const addCounter = startDate !== item.startDate || endDate !== item.endDate;

    if (startDate && addCounter) {
      return {
        counterStart: startDate,
        counterEnd: endDate,
        ...item,
      };
    }
    return item;
  });

  // THIS FUNCTION GIVES HOURS BASED ON A LIMIT
  return { totalShifts };
};

export default useGetLongTermDistributions;
